import { createContext, useContext } from 'react';
import { Expense } from '../../shared/models/expense';

export interface ContextExpense {
	id?: string;
	circleId: string;
	isSettlement: boolean;
	description?: string;
	currency?: string;
	amount?: number | string;
	creditors?: ContextExpenseUser[];
	debtors?: ContextExpenseUser[];
	dateTime?: Date;
	createdAt?: Date;
	createdById: string;
}

export interface ContextExpenseUser {
	id: string;
	circleId: string;
	amount?: number | string;
	currency?: string;
	isChecked?: boolean;
	name?: string;
	countryCode?: number;
	phoneNumber?: string;
}

interface ExpenseContextProps {
	expense?: ContextExpense;
	setExpense: (expense: ContextExpense) => void;
	getFinalExpense: () => Expense | undefined;
}

export const ExpenseContext = createContext<ExpenseContextProps | undefined>(undefined);

export const useExpenseContext = () => {
	const context = useContext(ExpenseContext);
	if (!context) {
		throw new Error('useExpenseContext must be used within a ExpenseProvider');
	}
	return context;
};
